import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {
  Card,
  CardContent,
  CardActions,
  Button,
  CardHeader,
  Grid,
} from "@mui/material";
import { Formik, Form, FieldArray, useFormik } from "formik";
import {
  BasicSelect,
  CloseButton,
  MonthAndYearPicker,
  SearchSelect,
  TextInput,
  TextInputPercentage,
} from "./components";
import { step2FormSchema } from "./form-schema";
import { GetCourses } from "../Actions/CommonAction";

const courseOptions = [
  { value: "10", label: "10th" },
  { value: "12", label: "12th" },
  { value: "diploma", label: "Diploma" },
  { value: "ug", label: "UG" },
  { value: "pg", label: "PG" },
];

function EducationDetails({
  showCloseBtn,
  showAddMore,
  onAddMoreClick,
  onCloseClick,
  idx,
}) {
  const [courses, setCourses] = useState([]);
  useEffect(() => {
    GetCourses({ status: 1 }).then((res) => {
      const dummycourse = res.data.map((item) => {
        return { value: item.id, label: item.name };
      });
      setCourses(dummycourse);
    });
  }, []);
  return (
    <Card sx={{ mb: 2 }}>
      <CardHeader
        sx={{ p: 0, px: 2, pt: showCloseBtn ? 1 : 2 }}
        action={showCloseBtn ? <CloseButton onClick={onCloseClick} /> : null}
      />
      <CardContent sx={{ p: 0, px: 2 }}>
        <Grid container spacing={2} mb={1.5}>
          <Grid item xs={4}>
            <BasicSelect
              label="Qualification"
              name={`educationalDetails.${idx}.qualification`}
              options={courseOptions}
            />
          </Grid>
          <Grid item xs={8}>
            <TextInput
              label="University or Board"
              name={`educationalDetails.${idx}.uniOrBoard`}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextInput
              label="College or School"
              name={`educationalDetails.${idx}.colOrSch`}
            />
          </Grid>
          <Grid item xs={6}>
            <SearchSelect
              label="Courses"
              name={`educationalDetails.${idx}.course`}
              options={courses}
            />
          </Grid>
          <Grid item xs={3}>
            <MonthAndYearPicker
              label="Graduation Month & Year"
              name={`educationalDetails.${idx}.gradMonthYear`}
            />
          </Grid>
          <Grid item xs={3}>
            <TextInputPercentage
              label="Percentage"
              name={`educationalDetails.${idx}.percentage`}
            />
          </Grid>
        </Grid>
      </CardContent>
      {showAddMore ? (
        <CardActions sx={{ p: 1, px: 2 }}>
          <Button onClick={onAddMoreClick} size="small">
            Add More
          </Button>
        </CardActions>
      ) : null}
    </Card>
  );
}

const generateInitialData = () => {
  return {
    id: `${moment().unix()}`,
    qualification: "",
    uniOrBoard: "",
    colOrSch: "",
    gradMonthYear: moment().toString(),
    percentage: "",
  };
};

export const EducationDetailsList = ({ push, remove, form }) => {
  const { values } = form;
  const list = values.educationalDetails;
  return (
    <Form>
      {list.map((item, idx, list) => (
        <EducationDetails
          key={item.id}
          idx={idx}
          showCloseBtn={idx > 0}
          showAddMore={list.length - 1 === idx}
          onAddMoreClick={() => push({ ...generateInitialData() })}
          onCloseClick={() => remove(idx)}
        />
      ))}
    </Form>
  );
};

function Step2({ getFormValidity, getData, data = {} }) {
  const [isInitialValid, setIsInitialValid] = useState(false);

  const { validateForm } = useFormik({
    validationSchema: step2FormSchema,
    initialValues: getInitialData(),
  });

  useEffect(() => {
    validateInitial();
  }, []);

  async function validateInitial() {
    const response = await validateForm();
    setIsInitialValid(Object.values(response).length === 0);
  }

  function getInitialData() {
    return data.educationalDetails || [{ ...generateInitialData() }];
  }

  return (
    <Formik
      initialValues={{ educationalDetails: getInitialData() }}
      validationSchema={step2FormSchema}
      isInitialValid={isInitialValid}
      render={({ isValid, values }) => {
        getData(2, values);
        getFormValidity(isValid);
        return (
          <FieldArray
            name="educationalDetails"
            component={EducationDetailsList}
          />
        );
      }}
    />
  );
}

export default Step2;
